import { render, staticRenderFns } from "./sopRecall.vue?vue&type=template&id=5445222e&"
import script from "./sopRecall.vue?vue&type=script&lang=js&"
export * from "./sopRecall.vue?vue&type=script&lang=js&"
import style0 from "./sopRecall.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports